//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AppHeaderMasthead',

  data() {
    return {
      showModal: false,
      showMenu: false
    }
  },

  computed: {
    ...mapState('user', ['details']),
    ...mapGetters('user', ['isGuest', 'isSubscriber']),

    menuClasses() {
      return {
        'is-open': this.showMenu
      }
    },

    isUK() {
      return this.$store.getters['ui/getHostname'].includes('co.uk')
    }
  },

  mounted() {
    this.showModal =
      this.isGuest && Boolean(window?.location?.hash === '#login')
  }
}
